import React from 'react';

export default (props) => {
  return props.render ? (<iframe id={props.id} src={props.src} name={props.name} onLoad={props.onIframeLoad}/>)
    : null
}


// WEBPACK FOOTER //
// ./src/components/projectSummary/iframe.js